import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LaborManagement_ds_work_classes_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, Priority?: number, EquipmentTypes?: { Id?: number, EquipmentType?: { LookupCode?: string } }[], OperationCodes?: { Id?: number, OperationCode?: { Name?: string } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_work_classes_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, Priority?: number, EquipmentTypes?: { Id?: number, EquipmentType?: { LookupCode?: string } }[], OperationCodes?: { Id?: number, OperationCode?: { Name?: string } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_work_classes_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, Priority?: number, EquipmentTypes?: { Id?: number, EquipmentType?: { LookupCode?: string } }[], OperationCodes?: { Id?: number, OperationCode?: { Name?: string } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_work_classes_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string    }) {
      return false;
    }
}
